var module = angular.module('new-event');

// NOTE: we intentionally use old-school directive rather than component
// so we can inherit parent controller/scope and allow toggling between
// 2 view modes without destroying state of controller.
//
// The templates files rely on `vm` which is included via the parent scope.
//
// These are essentially utilized as ng-include's but work better with our
// webpack setup this way.

// Top Level Components
//    * <new-event-quick />
//    * <new-event-wizard />
module.directive('newEventQuick', () => {
  return {
    restrict: 'E',
    template: require('./new-event-quick.html'),
  };
});

module.directive('newEventWizard', () => {
  return {
    restrict: 'E',
    template: require('./new-event-wizard.html'),
  };
});



// WEBPACK FOOTER //
// ./app/pages/new-event/directives.js